import React, { useState, useEffect, Suspense } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useIsMobile } from "@/hooks/use-mobile";
import { Search } from "lucide-react";
import DesktopNavigation from "./Navigation/DesktopNavigation";
import HeaderActions from "./Navigation/HeaderActions";

// Lazy-load components that are not critical for the initial render
const MobileNavigation = React.lazy(() => import("./Navigation/MobileNavigation"));
const CartDialog = React.lazy(() => import('./Cart/CartDialog').then(module => ({ default: module.CartDialog })));

const Header = () => {
  const { currentUser } = useAuth();
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-gaming-dark py-4 sticky top-0 z-40 border-b border-gaming-darker">
      <div className="container mx-auto px-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold text-gaming-blue">BattleforgePC</span>
          </Link>
        </div>

        {/* Only render DesktopNavigation after hydration to avoid SSR/CSR mismatch */}
        {!isMobile && isHydrated && <DesktopNavigation />}

        <div className="flex items-center">
          <HeaderActions 
            isMobile={isMobile} 
            isAuthenticated={!!currentUser} 
            onMobileMenuToggle={handleMobileMenuToggle} 
            CartComponent={CartDialog}
          />
        </div>
      </div>

      {/* Render lazy-loaded components inside Suspense */}
      {/* These components are not visible by default and will be loaded on demand */}
      <Suspense fallback={null}>
        <MobileNavigation 
          isOpen={isMobile && mobileMenuOpen} 
          onClose={() => setMobileMenuOpen(false)}
          isAuthenticated={!!currentUser}
        />
      </Suspense>
    </header>
  );
};

export default Header;
